import { Button, FormControl, Grid, ListItemText, MenuItem, Select } from "@mui/material";
import { MobileDatePicker } from "@mui/x-date-pickers";
import React, { useContext, useState } from "react";
import DateLocalizationProvider from "../../../../components/element/DateLocalizationProvider";
import {
  BADGE_TYPES,
  DATE_FORMAT,
  ESCORT_SERVICE_STATUS,
} from "../../../../utils/constants";
import "../ViewSpecialOnBoarding.css";
import dayjs from "dayjs";
import { StorageContext } from "../../../../services/StorageProvider";
import SearchAirlineDialog from "../../../../components/element/SearchAirlineDialog";
import SearchAirportDialog from "../../../../components/element/SearchAirportDialog";
import BadgesFilterSelect from "../../../../components/element/BadgesFilterSelect";
import { useFormData } from "../../../../helpers/FormDataProvider";

const SpecialOnBoardingFilter = ({ onApplyFilters, onClearFilters }) => {
  const [selectedEscortDepartureStatus, setSelectedEscortDepartureStatus] =
    useState("");
  const [selectedEscortArrivalStatus, setSelectedEscortArrivalStatus] =
    useState("");
  const [selectedDepartureDate, setSelectedDepartureDate] = useState();
  const [selectedArrivalAirport, setSelectedArrivalAirport] = useState(null);
  const [selectedDepartureAirport, setSelectedDepartureAirport] =
    useState(null);
  const [selectedAirline, setSelectedAirline] = useState("");
  const [showSearchAirlineDialog, setShowSearchAirlineDialog] = useState(false);
  const [showSearchArrivalAirportDialog, setShowSearchArrivalAirportDialog] =
    useState(false);
  const [
    showSearchDepartureAirportDialog,
    setShowSearchDepartureAirportDialog,
  ] = useState(false);
  const { airportData } = useContext(StorageContext);
  const { userData } = useFormData();
  const [selectedBadges, setSelectedBadges] = useState([]);

  const handleSearchAirlineChange = (airline) => {
    setSelectedAirline(airline);
  };

  const handleSearchArrivalAirportChange = (airport) => {
    setSelectedArrivalAirport(airport);
  };

  const handleSearchDepartureAirportChange = (airport) => {
    setSelectedDepartureAirport(airport);
  };

  const handleEscortDepartureStatusToggle = (event) => {
    setSelectedEscortDepartureStatus(event.target.value);
  };

  const handleEscortArrivalStatusToggle = (event) => {
    setSelectedEscortArrivalStatus(event.target.value);
  };

  const handleDepartureDateChange = (newValue) => {
    setSelectedDepartureDate(newValue);
  };

  const handleClear = () => {
    setSelectedEscortDepartureStatus("");
    setSelectedEscortArrivalStatus("");
    setSelectedDepartureDate(null);
    setSelectedArrivalAirport(null);
    setSelectedDepartureAirport(null);
    setSelectedAirline("");
    setSelectedBadges([]);

    if (onClearFilters) {
      onClearFilters();
    }
  };

  const handleApply = () => {
    const filters = {
      escortDepartureStatus: selectedEscortDepartureStatus,
      escortArrivalStatus: selectedEscortArrivalStatus,
      departureDate: selectedDepartureDate
        ? dayjs(selectedDepartureDate).format("YYYY-MM-DD")
        : "",
      airlineId: selectedAirline?.id ?? "",
      arrivalAirportId: selectedArrivalAirport?.id || "",
      departureAirportId: selectedDepartureAirport?.id || "",
      ...(userData?.isAAUser &&
        selectedBadges.includes(BADGE_TYPES.ADSB_VERIFIED) && {
          [BADGE_TYPES.ADSB_VERIFIED]: true,
        }),
      ...(userData?.isAAUser &&
        selectedBadges.includes(BADGE_TYPES.BMS_VERIFIED) && {
          [BADGE_TYPES.BMS_VERIFIED]: true,
        }),
    };

    if (onApplyFilters) {
      onApplyFilters(filters);
    }
  };

  return (
    <div className="view-special-onboarding-filter-container">
      <Grid container spacing={1.5}>
        <Grid item>
          <FormControl variant="outlined">
            <div className="view-special-onboarding-filter-header">
              Select Airline
            </div>
            <div
              className="view-special-onboarding-filter-select-airline"
              onClick={() => setShowSearchAirlineDialog(true)}
            >
              {selectedAirline ? (
                <p>{selectedAirline?.airlineName}</p>
              ) : (
                <span className="placeholder-text">Select</span>
              )}
            </div>
          </FormControl>
        </Grid>
        <Grid item>
          <FormControl variant="outlined">
            <div className="view-special-onboarding-filter-header">
              Arrival Airport
            </div>
            <div
              className="view-special-onboarding-filter-select-airline"
              onClick={() => setShowSearchArrivalAirportDialog(true)}
            >
              {selectedArrivalAirport ? (
                <p>{selectedArrivalAirport?.name}</p>
              ) : (
                <span className="view-special-onboarding-filter-select-placeholder">
                  Search
                </span>
              )}
            </div>
          </FormControl>
        </Grid>
        <Grid item>
          <FormControl variant="outlined">
            <div className="view-special-onboarding-filter-header">
              Departure Airport
            </div>
            <div
              className="view-special-onboarding-filter-select-airline"
              onClick={() => setShowSearchDepartureAirportDialog(true)}
            >
              {selectedDepartureAirport ? (
                <p>{selectedDepartureAirport?.name}</p>
              ) : (
                <span className="view-special-onboarding-filter-select-placeholder">
                  Search
                </span>
              )}
            </div>
          </FormControl>
        </Grid>

        <Grid item>
          <FormControl variant="outlined">
            <div className="view-special-onboarding-filter-header">
              Badges
            </div>
            <BadgesFilterSelect
              selectedBadges={selectedBadges}
              onChange={setSelectedBadges}
              selectClassName="view-special-onboarding-filter-select-container view-special-onboarding-filter-select-badges"
            />
          </FormControl>
        </Grid>

        <DateLocalizationProvider>
          <Grid item>
            <FormControl variant="outlined">
              <div className="view-special-onboarding-filter-header">
                Departure Date
              </div>
              <MobileDatePicker
                id="view-special-onboarding-filter-from-datepicker"
                className="view-special-onboarding-filter-datepicker"
                format={DATE_FORMAT}
                minDate={dayjs()}
                value={selectedDepartureDate}
                onChange={handleDepartureDateChange}
              />
            </FormControl>
          </Grid>
        </DateLocalizationProvider>

        <Grid item>
          <FormControl variant="outlined">
            <div className="view-special-onboarding-filter-header">
              Departure Status
            </div>
            <Select
              className="view-special-onboarding-filter-select-container"
              value={selectedEscortDepartureStatus}
              onChange={handleEscortDepartureStatusToggle}
              displayEmpty
              renderValue={(selected) =>
                selected ? (
                  ESCORT_SERVICE_STATUS.find((type) => type.value === selected)
                    ?.name
                ) : (
                  <span className="view-special-onboarding-filter-select-placeholder">
                    Select Status
                  </span>
                )
              }
            >
              {ESCORT_SERVICE_STATUS.map((type) => (
                <MenuItem key={type.value} value={type.value}>
                  <ListItemText primary={type.name} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item>
          <FormControl variant="outlined">
            <div className="view-special-onboarding-filter-header">
              Arrival Status
            </div>
            <Select
              className="view-special-onboarding-filter-select-container"
              value={selectedEscortArrivalStatus}
              onChange={handleEscortArrivalStatusToggle}
              displayEmpty
              renderValue={(selected) =>
                selected ? (
                  ESCORT_SERVICE_STATUS.find((type) => type.value === selected)
                    ?.name
                ) : (
                  <span className="view-special-onboarding-filter-select-placeholder">
                    Select Status
                  </span>
                )
              }
            >
              {ESCORT_SERVICE_STATUS.map((type) => (
                <MenuItem key={type.value} value={type.value}>
                  <ListItemText primary={type.name} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
      </Grid>
      <Grid className="filter-buttons">
        <Button
          variant="text"
          color="primary"
          onClick={handleClear}
          className="filter-button"
        >
          Clear
        </Button>
        <Button
          variant="contained"
          color="secondaryButton"
          onClick={handleApply}
        >
          Apply
        </Button>
      </Grid>
      <SearchAirlineDialog
        open={showSearchAirlineDialog}
        onClose={() => setShowSearchAirlineDialog(false)}
        onSelectAirline={handleSearchAirlineChange}
      />
      <SearchAirportDialog
        open={showSearchArrivalAirportDialog}
        onClose={() => setShowSearchArrivalAirportDialog(false)}
        airportData={airportData}
        onSelectAirport={handleSearchArrivalAirportChange}
      />
      <SearchAirportDialog
        open={showSearchDepartureAirportDialog}
        onClose={() => setShowSearchDepartureAirportDialog(false)}
        airportData={airportData}
        onSelectAirport={handleSearchDepartureAirportChange}
      />
    </div>
  );
};

export default SpecialOnBoardingFilter;
